"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectEntryPoint = void 0;
const React = __importStar(require("react"));
const ProjectUrlProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectUrlProvider");
const ProjectErrorActorPage_1 = require("src/configeek_assets/src/components/loggedIn/content/project/error/ProjectErrorActorPage");
const ProjectConfigStoreDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectConfigStoreDataProvider");
const ProjectWithDataComponent_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/ProjectWithDataComponent");
const CurrentProjectProvider_1 = require("src/configeek_assets/src/components/common/provider/CurrentProjectProvider");
const react_router_dom_1 = require("react-router-dom");
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const PrivateRoute_1 = require("src/configeek_assets/src/components/common/widget/PrivateRoute");
const ProjectMembersPage_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/members/ProjectMembersPage");
const ProjectParticipantsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectParticipantsDataProvider");
const ProjectSettingsPage_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/settings/ProjectSettingsPage");
const ProjectEntryPoint = () => {
    const { projectData } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const { projectApiKey } = (0, ProjectUrlProvider_1.useProjectUrlContext)();
    const routeMatch = (0, react_router_dom_1.useRouteMatch)(AppRouter_1.PATH__PROJECT);
    // console.log("ProjectEntryPoint: routeMatch", routeMatch);
    if (projectData.api == undefined || projectData.error != undefined) {
        return React.createElement(ProjectErrorActorPage_1.ProjectErrorActorPage, { error: projectData.error });
    }
    if (routeMatch && !AppRouter_1.PathChecker.isProjectSectionValid(routeMatch.params.section)) {
        // console.log("ProjectEntryPoint: invalid section => redirect");
        return React.createElement(react_router_dom_1.Redirect, { to: AppRouter_1.PathGenerator.project(routeMatch.params.projectApiKey) });
    }
    return React.createElement(ProjectConfigStoreDataProvider_1.ProjectConfigStoreDataProvider, { configStoreCanisterId: projectData.api.canisterId, accessToken: projectData.api.accessToken, projectApiKey: projectApiKey },
        React.createElement(ProjectParticipantsDataProvider_1.ProjectParticipantsDataProvider, { projectApiKey: projectApiKey },
            React.createElement(react_router_dom_1.Switch, null,
                React.createElement(PrivateRoute_1.PrivateRoute, { path: AppRouter_1.PATH__PROJECT_MEMBERS, exact: true, component: ProjectMembersPage_1.ProjectMembersPage }),
                React.createElement(PrivateRoute_1.PrivateRoute, { path: AppRouter_1.PATH__PROJECT_SETTINGS, exact: true, component: ProjectSettingsPage_1.ProjectSettingsPage }),
                React.createElement(ProjectWithDataComponent_1.ProjectWithDataComponent, null))));
};
exports.ProjectEntryPoint = ProjectEntryPoint;
